import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { sendHeartbeat } from "@/lib/liveTracker";

// Envoie un battement de cœur (présence + page) au chargement, à chaque changement
// de route, et toutes les 12s. Ignore les pages admin (analytics = site public).
export default function LiveTracker() {
  const { pathname } = useLocation();
  const pathRef = useRef(pathname);
  pathRef.current = pathname;

  const isTracked = !pathname.startsWith("/admin");

  useEffect(() => {
    if (!isTracked) return;
    sendHeartbeat(pathname);
  }, [pathname, isTracked]);

  useEffect(() => {
    const id = setInterval(() => {
      if (!pathRef.current.startsWith("/admin")) sendHeartbeat(pathRef.current);
    }, 12000);
    return () => clearInterval(id);
  }, []);

  return null;
}
